import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import customTheme from 'app/style/theme';
import 'app/E2Book.css';

import { Box, Grommet } from 'grommet';

import LayoutEngine from 'app/components/LayoutEngine';
import Underlay from 'app/components/Underlay';

import TableOfContents from 'app/components/BookElements/TableOfContents';
import Bookmarks from 'app/components/BookElements/Bookmarks';
import SearchResults from 'app/components/SearchResults';

import MenuBar from 'app/components/Menu/MenuBar';
import MainMenu from 'app/components/MainMenu/MainMenu';
import BookmarksMenu from 'app/components/BookmarkMenu/BookmarksMenu';
import DeleteBookmarkMenu from 'app/components/BookmarkMenu/DeleteBookmarkMenu';
import ClearBookmarksMenu from 'app/components/BookmarkMenu/ClearBookmarksMenu';
import BookmarkingMenu from 'app/components/BookmarkMenu/BookmarkingMenu';
import AddNoteMenu from 'app/components/BookmarkMenu/AddNoteMenu';
import AwaitingSelectionMenu from 'app/components/BookmarkMenu/AwaitingSelectionMenu';
import NoteInput from 'app/components/BookmarkMenu/NoteInput';

class E2Book extends Component {
  render() {
    return (
      <Grommet className="App" full theme={customTheme}>
        <Box fill align="center">
          <Underlay />
          <TableOfContents aria-label="table of contents"/>
          <Bookmarks aria-label="bookmarks"/>
          <SearchResults aria-label="search results"/>
          <LayoutEngine />
          <NoteInput aria-label="note input"/>
          <MenuBar aria-label="menu bar">
            <MainMenu aria-label="main menu"/>
            <BookmarksMenu aria-label="bookmarks menu"/>
            <BookmarkingMenu aria-label="bookmarking menu"/>
            <DeleteBookmarkMenu aria-label="delete bookmark menu"/>
            <ClearBookmarksMenu aria-label="clear bookmarks menu"/>
            <AwaitingSelectionMenu aria-label="awaiting selection"/>
            <AddNoteMenu aria-label="annotate bookmark menu"/>
          </MenuBar>
        </Box>
      </Grommet>
    );
  }
}

export default inject('AppState')(observer(E2Book));



// WEBPACK FOOTER //
// ./src/app/E2Book.js